const TRUSTED_DEVELOPER_NAME = 'AhaSlides'

// Trust comes only from the marketplace feed's `trustedPages`, never from a manifest.
export const applyTrustedPages = (items, trustedPages) => {
  if (!Array.isArray(items) || !Array.isArray(trustedPages) || !trustedPages.length) return items
  const trustedIds = new Set()
  trustedPages.forEach((entry) => {
    if (entry && Array.isArray(entry.pageIds)) entry.pageIds.forEach((id) => trustedIds.add(id))
  })
  if (!trustedIds.size) return items
  return items.map((item) => (item && trustedIds.has(item.pageId)
    ? { ...item, developer: TRUSTED_DEVELOPER_NAME, trustedDeveloper: true }
    : item))
}
